import {Link} from 'react-scroll'
import Logomarca from '../../assets/images/logo_lideres.png';


const Header = () => {
    return (
        <header className='fixed-top'>
            <nav className="navbar navbar-expand-lg">
                <div className="container">
                    <Link className="navbar-brand" to="banner" spy={true} smooth={true} duration={100}>
                        <img
                            src={Logomarca}
                            width={150}
                            alt="Líderes do Sucesso Team Edition 2022"
                        />
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav my-auto mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link" activeClass="active" to="banner" spy={true} smooth={true} duration={100}>Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="sobre-evento" spy={true} smooth={true} duration={100}>O Evento</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="nossos-convidados" spy={true} smooth={true} duration={100}>Convidados</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="commercial-edition" spy={true} smooth={true} duration={100}>Comercial edition</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="qr-code" spy={true} smooth={true} duration={100}>Mídias</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="local" spy={true} smooth={true} duration={100}>Local</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    )
}

export default Header;